export default "__VITE_ASSET__nz6YaOT9__"